import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sm-new-upload-media',
  templateUrl: './new-upload-media.component.html',
  styleUrls: ['./new-upload-media.component.scss']
})
export class NewUploadMediaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
